import React from "react"
export function Travellers(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M6.873 9.385c2.416 0 4.375 1.928 4.375 4.307V18h-8.75v-4.308c0-2.379 1.959-4.307 4.375-4.307zm7.5 2.461c1.726 0 3.125 1.378 3.125 3.077V18h-4.375v-4.3c0-.52-.022-1.025-.145-1.507a2.95 2.95 0 011.395-.347zm.03-6.154c1.381 0 2.5 1.102 2.5 2.462s-1.119 2.461-2.5 2.461c-1.38 0-2.5-1.102-2.5-2.461 0-1.36 1.12-2.462 2.5-2.462zM6.873 2C8.6 2 9.998 3.378 9.998 5.077c0 1.7-1.399 3.077-3.125 3.077S3.748 6.776 3.748 5.077c0-1.7 1.4-3.077 3.125-3.077z"
        fill="currentColor"
        id="prefix__travellers"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
